import React from "react";
import { Link } from "react-router-dom";
import { organisation, pedagogyItems } from "../../data/clearith";

const AboutContent: React.FC = () => (
  <>
    <section className="cl-page-section">
      <div className="container">
        <div className="row gy-5 align-items-start">
          <div className="col-lg-7">
            <span className="cl-kicker">Notre mission</span>
            <h2 className="cl-section-title">
              Transformer un objectif professionnel en compétences concrètes.
            </h2>
            <p className="cl-lead">
              CLEARITH accompagne les actifs, les personnes en recherche
              d’emploi, les indépendants, les entrepreneurs, les managers et
              les dirigeants dans le développement et la certification de leurs
              compétences.
            </p>
            <p className="cl-body-copy">
              Notre approche repose sur des parcours lisibles, des activités
              pratiques, un suivi pédagogique régulier et une préparation
              structurée à la certification visée. Chaque participant bénéficie
              d’un cadre conçu pour favoriser l’engagement, l’autonomie et le
              transfert des acquis dans son activité professionnelle.
            </p>
          </div>
          <div className="col-lg-5">
            <aside className="cl-info-panel">
              <span className="cl-info-panel__label">Identité</span>
              <h3>{organisation.name}</h3>
              <dl>
                <div>
                  <dt>Statut</dt>
                  <dd>{organisation.legalForm}</dd>
                </div>
                <div>
                  <dt>Déclaration d’activité</dt>
                  <dd>{organisation.activityDeclaration}</dd>
                </div>
                <div>
                  <dt>Région</dt>
                  <dd>{organisation.declarationRegion}</dd>
                </div>
                <div>
                  <dt>Qualiopi</dt>
                  <dd>{organisation.qualiopiScope}</dd>
                </div>
              </dl>
            </aside>
          </div>
        </div>
      </div>
    </section>

    <section className="cl-page-section cl-surface-section">
      <div className="container">
        <div className="cl-section-heading">
          <div>
            <span className="cl-kicker">Notre approche</span>
            <h2 className="cl-section-title">
              Un accompagnement présent à chaque étape.
            </h2>
          </div>
          <p className="cl-lead">
            Le parcours est organisé pour rendre les objectifs, les activités
            et la progression compréhensibles dès le départ.
          </p>
        </div>
        <div className="row g-4">
          {pedagogyItems.slice(0, 4).map((item) => (
            <div className="col-lg-3 col-md-6" key={item.number}>
              <article className="cl-method-card cl-method-card--light">
                <span>{item.number}</span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="cl-page-section">
      <div className="container">
        <div className="cl-two-cards">
          <article>
            <span className="cl-kicker">Qualité</span>
            <h3>Certifié Qualiopi pour les actions de formation</h3>
            <p>
              CLEARITH inscrit son activité dans une démarche de qualité,
              d’information des participants et d’amélioration continue.
            </p>
          </article>
          <article>
            <span className="cl-kicker">Accessibilité</span>
            <h3>Des besoins étudiés avant le démarrage</h3>
            <p>
              Un échange préalable permet d’identifier les aménagements qui
              peuvent être envisagés pour les personnes en situation de
              handicap.
            </p>
            <Link className="cl-text-link" to="/accessibilite">
              Consulter notre démarche <span aria-hidden="true">↗</span>
            </Link>
          </article>
        </div>
      </div>
    </section>
  </>
);

export default AboutContent;
